<template>
    <section class="portal" v-bind:class="{ 'mobile': this.$store.getters.isMobile }">
        <div class="container first">
            <MobileMenu v-if="this.$store.getters.isMobile" />
            <section class="dashboard" v-if="selectedDrivers.length > 0" v-bind:class="{ 'show': this.isMobileDashboardOpen }">
                <h1 class="text-large-heading">User Dashboard</h1>
                <h2 class="text-sub-heading">Results Overview</h2>

                <div class="grid js-match-card-height">

                    <div class="col-2" @click="toggleDriversAccordion">
                        <div class="card is-small" v-bind:class="{ 'collapsed': !driversAccordionOpen }">
                            <div class="card__body">
                                <h3 class="text-base text-weight-500">Value Driver Ranking</h3>
                                <p class="text-weight-500">Selected</p>
                                <ol>
                                    <li v-for="(driver, index) in selectedDrivers" :key="driver.name+'_selected-list'">{{driver.name}}</li>
                                </ol>
                                <p class="text-weight-500">Unselected</p>
                                <ul class="list-dash">
                                    <li v-for="(driver,index) in unselectedDrivers" :key="driver.name+'_unselected-list'">{{driver.name}}</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-2" v-for="(driver, index) in drivers" :key="driver.name+'_card'">
                        <driver-card :driver="driver" :driversAccordionOpen="driversAccordionOpen" v-bind:expandDriversParent="expandCards"></driver-card>
                    </div>
                    <div class="accordion-container" v-bind:class="{ 'show': !driversAccordionOpen }" v-if="!this.$store.getters.isMobile">
                        <button type="button" @click="toggleDriversAccordion">
                            <img v-bind:class="{ 'up': driversAccordionOpen }" src="./../../img/chevron-down.svg">
                            <h4>
                                <span v-if="!driversAccordionOpen">Show Results</span>
                                <span v-if="driversAccordionOpen">Hide Results</span>
                            </h4>
                        </button>
                    </div>
                </div>
            </section>

            <section class="feed" v-bind:class="{ 'has-dashboard' : this.selectedDrivers.length }">
                <div class="flex-row">
                    <h2 class="text-large-heading" v-if="selectedDrivers.length > 0">Your Customized Results</h2>
                    <ResultsFilter v-bind:updateCardsParent="getFilteredPosts" />
                </div>

                <div class="grid card-grid">

                    <template v-if="posts">
                        <masonry :cols="{default: 4, 992: 3, 768: 2, 480: 1}" class="first-child">
                            <div class="card-grid-col col-auto" v-for="(post,index) in posts" :key="index" :data-key="index" v-if="post.value_driver[Object.keys(post.value_driver)[0]]">
                                <article class="card-flip card-grid-item" v-if="post.source_name || post.source_title">
                                    <div class="card card--front">
                                        <header class="card__header">
                                            <div class="card__header__icon">
                                                <div v-for="(driver, driver_index) in post.value_driver" :key="driver.name+driver_index">
                                                    <svg v-if="driver_index == Object.keys(post.value_driver)[0]" class="icon" :class="['icon-'+driver.abbreviation+'-circle', driver.color]"><use v-bind="{'xlink:href':'#icon-'+driver.abbreviation+'-circle'}"></use></svg>
                                                </div>
                                            </div>
                                            <div class="card__header__text" v-if="post.value_driver[Object.keys(post.value_driver)[0]] && post.value_driver[Object.keys(post.value_driver)[1]]">
                                                <p class="text-regular">{{post.value_driver[Object.keys(post.value_driver)[0]].name}}</p>
                                                <p class="text-meta-heading">{{post.value_driver[Object.keys(post.value_driver)[1]].name}}</p>
                                            </div>
                                        </header>

                                        <section class="card__body">
                                            <h3 class="text-meta-heading">{{post.organization}}</h3>
                                            <p class="text-intro-text">{{post.summary_content}}</p>
                                            <p class="text-small-heading">
                                                {{post.source_name}}<template v-if="post.source_certification">, {{post.source_certification}}</template>
                                            </p>
                                            <p class="text-meta-heading">{{post.source_title}}</p>
                                        </section>

                                        <div class="card__footer">
                                            <button class="button has-icon is-small text-white"
                                                @click="flipCard"
                                                v-if="post.value_driver[Object.keys(post.value_driver)[0]]"
                                                :class="post.value_driver[Object.keys(post.value_driver)[0]].color">
                                                <svg class="icon icon-Quote"><use xlink:href="#icon-Quote"></use></svg> Client Testimonial Details
                                            </button>
                                        </div>
                                    </div>

                                    <div class="card card--back">
                                        <header class="card__header">
                                            <div class="card__header__text">
                                                <p class="h3">Quote Details</p>
                                            </div>
                                            <div class="card__header__action">
                                                <button class="card-close" @click="flipCard"><svg class="icon icon-Close"><use xlink:href="#icon-Close"></use></svg></button>
                                            </div>
                                        </header>

                                        <section class="card__body">
                                            <h3 class="text-meta-heading">Organization</h3>
                                            <p class="text-small-heading">{{post.organization}}</p>
                                            <h3 class="text-meta-heading">Date Captured</h3>
                                            <p class="text-small-heading">{{post.date_captured}}</p>
                                            <h3 class="text-meta-heading">Source</h3>
                                            <p class="text-small-heading">
                                                {{post.source_name}}<template v-if="post.source_certification">, {{post.source_certification}}</template>
                                                <br>{{post.source_title}}
                                            </p>
                                            <h3 class="text-meta-heading">Value Driver</h3>
                                            <p class="text-small-heading">
                                                <template v-for="(driver, driver_index) in post.value_driver">
                                                    {{driver.name}}<br>
                                                </template>
                                            </p>
                                        </section>
                                    </div>
                                </article>

                                <article class="card card-grid-item" v-else-if="post.video_link" :data-video="getVideoId(post.video_link)">
                                    <header class="card__header">
                                        <div class="card__header__icon">
                                            <div v-for="(driver, driver_index) in post.value_driver" :key="driver.name+driver_index">
                                                <svg v-if="driver_index == Object.keys(post.value_driver)[0]" class="icon" :class="['icon-'+driver.abbreviation+'-circle', driver.color]"><use v-bind="{'xlink:href':'#icon-'+driver.abbreviation+'-circle'}"></use></svg>
                                            </div>
                                        </div>
                                        <div class="card__header__text" v-if="post.value_driver[Object.keys(post.value_driver)[0]] && post.value_driver[Object.keys(post.value_driver)[1]]">
                                            <p class="text-regular">{{post.value_driver[Object.keys(post.value_driver)[0]].name}}</p>
                                            <p class="text-meta-heading">{{post.value_driver[Object.keys(post.value_driver)[1]].name}}</p>
                                        </div>
                                    </header>

                                    <div class="card__img img-fit has-video" @click="activateVideo(getVideoId(post.video_link),post.organization, post.headline )">
                                        <img :src="'https://i.ytimg.com/vi/'+getVideoId(post.video_link)+'/hqdefault.jpg'">
                                        <svg class="icon icon-Play"><use xlink:href="#icon-Play"></use></svg>
                                    </div>

                                    <section class="card__body">
                                        <h3 class="text-meta-heading">{{post.organization}}</h3>
                                        <p class="text-intro-text">{{post.headline}}</p>
                                    </section>

                                    <div class="card__footer">
                                        <button class="button has-icon is-small text-white" v-if="post.value_driver[Object.keys(post.value_driver)[0]]" :class="post.value_driver[Object.keys(post.value_driver)[0]].color" @click="activateVideo(getVideoId(post.video_link),post.organization, post.headline )"><svg class="icon icon-Play"><use xlink:href="#icon-Play"></use></svg> Play Video</button>
                                    </div>

                                </article>

                                <article class="card-flip card-grid-item" v-else-if="post.disclosure">
                                    <div class="card card--front">
                                        <header class="card__header">
                                            <div class="card__header__icon">
                                                <div v-for="(driver, driver_index) in post.value_driver" :key="driver.name+driver_index">
                                                    <svg v-if="driver_index == Object.keys(post.value_driver)[0]" class="icon" :class="['icon-'+driver.abbreviation+'-circle', driver.color]"><use v-bind="{'xlink:href':'#icon-'+driver.abbreviation+'-circle'}"></use></svg>
                                                </div>
                                            </div>
                                            <div class="card__header__text" v-if="post.value_driver[Object.keys(post.value_driver)[0]] && post.value_driver[Object.keys(post.value_driver)[1]]">
                                                <p class="text-regular">{{post.value_driver[Object.keys(post.value_driver)[0]].name}}</p>
                                                <p class="text-meta-heading">{{post.value_driver[Object.keys(post.value_driver)[1]].name}}</p>
                                            </div>
                                        </header>

                                        <section class="card__body">
                                            <h3 class="text-meta-heading">{{post.organization}}</h3>
                                            <p class="text-intro-text">{{post.summary_content}}</p>
                                            <!-- <img :src="'/storage/data_img/'+post.value_driver[Object.keys(post.value_driver)[0]].color+'.png'"> -->
                                            <img v-if="post.image" :src="'/storage/'+ checkImageUrl(post.image) ">
                                            <!-- <p class="text-meta-heading">{{post.disclosure}}</p> -->
                                        </section>

                                        <div class="card__footer">
                                            <button class="button has-icon is-small text-white" v-if="post.value_driver[Object.keys(post.value_driver)[0]]" :class="post.value_driver[Object.keys(post.value_driver)[0]].color" @click="flipCard"><svg class="icon icon-Info"><use xlink:href="#icon-Info"></use></svg> View Statistic Details</button>
                                        </div>

                                    </div>

                                    <div class="card card--back">
                                        <header class="card__header">
                                            <div class="card__header__text">
                                                <p class="h3">Statistic Details</p>
                                            </div>
                                            <div class="card__header__action">
                                                <button class="card-close" @click="flipCard"><svg class="icon icon-Close"><use xlink:href="#icon-Close"></use></svg></button>
                                            </div>
                                        </header>
                                        <section class="card__body">
                                            <h3 class="text-meta-heading">Organization</h3>
                                            <p class="text-small-heading">{{post.organization}}</p>
                                            <h3 class="text-meta-heading">Date Captured</h3>
                                            <p class="text-small-heading">{{post.date_captured}}</p>
                                            <h3 class="text-meta-heading">Disclosure</h3>
                                            <p class="text-small-heading">
                                                {{post.disclosure}}
                                            </p>
                                            <h3 class="text-meta-heading">Value Driver</h3>
                                            <p class="text-small-heading">
                                                <template v-for="(driver, driver_index) in post.value_driver">
                                                    {{driver.name}}<br>
                                                </template>
                                            </p>
                                        </section>
                                    </div>
                                </article>

                                <article class="card card-grid-item" v-else>
                                    <header class="card__header">
                                        <div class="card__header__icon">
                                            <div v-for="(driver, driver_index) in post.value_driver" :key="driver.name+driver_index">
                                                <svg v-if="driver_index == Object.keys(post.value_driver)[0]" class="icon" :class="['icon-'+driver.abbreviation+'-circle', driver.color]"><use v-bind="{'xlink:href':'#icon-'+driver.abbreviation+'-circle'}"></use></svg>
                                            </div>
                                        </div>
                                        <div class="card__header__text" v-if="post.value_driver[Object.keys(post.value_driver)[0]] && post.value_driver[Object.keys(post.value_driver)[1]]">
                                            <p class="text-regular">{{post.value_driver[Object.keys(post.value_driver)[0]].name}}</p>
                                            <p class="text-meta-heading">{{post.value_driver[Object.keys(post.value_driver)[1]].name}}</p>
                                        </div>
                                    </header>

                                    <div class="card__img img-fit" :class="post.value_driver[Object.keys(post.value_driver)[0]].color">
                                        <img :src="'/storage/'+ checkImageUrl(post.image) ">
                                    </div>

                                    <section class="card__body">
                                        <h3 class="text-meta-heading">{{post.organization}}</h3>
                                        <p class="text-intro-text">{{post.title}}</p>
                                    </section>

                                    <div class="card__footer">
                                        <a href="#" @click.prevent="activateStory(post)" class="button has-icon is-small" v-if="post.value_driver[Object.keys(post.value_driver)[0]]" :class="post.value_driver[Object.keys(post.value_driver)[0]].color"><svg class="icon icon-Article"><use xlink:href="#icon-Article"></use></svg> Read Client Achievement Story</a>
                                    </div>

                                </article>
                            </div>
                        </masonry>
                    </template>

                </div>

                <div class="load-more text-center">
                    <button class="button" @click="loadMore(page)" v-if="!noMorePosts">
                        <span v-if="!loadingResults">Load More Results</span>
                        <span v-if="loadingResults">Loading Results...</span>
                        <img src="./../../img/ajax-loader.gif" v-if="loadingResults">
                    </button>
                    <span class="load-more__no-results" v-if="noMorePosts">
                        <span v-if="emptyResult">No results found, please try other Drivers/Filters</span>
                    </span>
                </div>
            </section>
        </div>

        <transition name="component-fade" mode="out-in">
            <div class="popup video-popup" v-if="activeVideo.active">

                <vue-plyr :options="{hideControls:true,autoplay:this.autoPlay}" :emit="['ready','ended', 'timeupdate']" @ready="playVideo" @ended="deactivateVideo" @timeupdate="videoplaying">
                    <div data-plyr-provider="youtube" :data-plyr-embed-id="activeVideo.id"></div>
                </vue-plyr>

                <div class="container">
                    <button class="close-button" @click="deactivateVideo"><svg class="icon icon-Close"><use xlink:href="#icon-Close"></use></svg></button>
                    <div class="video-popup__title" :class="{ 'is-hidden': activeVideo.hideText }">
                        <p class="text-large-heading text-white popup-heading">{{activeVideo.subHeading}}</p>
                        <h3 class="text-callout text-white popup-heading">{{activeVideo.heading}}</h3>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="component-fade" mode="out-in">
            <div class="popup content-popup" v-if="activeStory.active">
                <header class="content-popup__banner" :style="{backgroundImage : 'url(/storage/' + checkImageUrl(activeStory.post.image), backgroundPosition: checkBackgroundPosition(activeStory.post.hero_alignment) }">
                    <div class="container">
                        <button class="close-button" @click="deactivateStory"><svg class="icon icon-Close"><use xlink:href="#icon-Close"></use></svg></button>
                        <p class="text-large-heading text-white popup-heading">{{activeStory.post.organization}}</p>
                        <h3 class="text-callout text-white popup-heading">{{activeStory.post.title}}</h3>

                        <div class="content-popup__meta">
                            <ul>
                                <li>
                                    <p class="text-light">Value Driver</p>
                                    <p class="text-small-heading">{{activeStory.post.value_driver[Object.keys(activeStory.post.value_driver)[0]].name}}</p>
                                </li>
                                <li>
                                    <p class="text-light">Sub Driver</p>
                                    <p class="text-small-heading">{{activeStory.post.value_driver[Object.keys(activeStory.post.value_driver)[1]].name}}</p>
                                </li>
                                <li>
                                    <p class="text-light">Date Posted</p>
                                    <p class="text-small-heading">{{activeStory.post.date_captured}}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </header>
                <div class="container">
                    <div class="grid justify-space-between">
                        <article class="col-7">
                            <div class="wysiwyg" v-html="activeStory.post.content">
                            </div>
                            <button class="content-popup__exit" @click="deactivateStory"><svg class="icon icon-Exit"><use xlink:href="#icon-Exit"></use></svg>Back to Dashboard</button>
                        </article>

                        <aside class="col-3">
                            <template v-if="relatedPosts">

                                <div class="card-grid-col col-auto" v-for="(post,index) in relatedPosts" :key="index+'_popupPost'" :data-key="index" v-if="post.value_driver[Object.keys(post.value_driver)[0]]">
                                    <article class="card-flip card-grid-item" v-if="post.source_name || post.source_title">
                                        <div class="card card--front">
                                            <header class="card__header">
                                                <div class="card__header__icon">
                                                    <div v-for="(driver, driver_index) in post.value_driver" :key="driver.name+driver_index">
                                                        <svg v-if="driver_index == Object.keys(post.value_driver)[0]" class="icon" :class="['icon-'+driver.abbreviation+'-circle', driver.color]"><use v-bind="{'xlink:href':'#icon-'+driver.abbreviation+'-circle'}"></use></svg>
                                                    </div>
                                                </div>
                                                <div class="card__header__text" v-if="post.value_driver[Object.keys(post.value_driver)[0]] && post.value_driver[Object.keys(post.value_driver)[1]]">
                                                    <p class="text-regular">{{post.value_driver[Object.keys(post.value_driver)[0]].name}}</p>
                                                    <p class="text-meta-heading">{{post.value_driver[Object.keys(post.value_driver)[1]].name}}</p>
                                                </div>
                                            </header>

                                            <section class="card__body">
                                                <h3 class="text-meta-heading">{{post.organization}}</h3>
                                                <p class="text-intro-text">{{post.summary_content}}</p>
                                                <p class="text-small-heading">
                                                    {{post.source_name}}
                                                    <template v-if="post.source_certification">
                                                        , {{post.source_certification}}
                                                    </template>
                                                </p>
                                                <p class="text-meta-heading">{{post.source_title}}</p>
                                            </section>

                                            <div class="card__footer">
                                                <button class="button has-icon is-small text-white" @click="flipCard" v-if="post.value_driver[Object.keys(post.value_driver)[0]]" :class="post.value_driver[Object.keys(post.value_driver)[0]].color"><svg class="icon icon-Quote"><use xlink:href="#icon-Quote"></use></svg> Client Testimonial Details</button>
                                            </div>
                                        </div>

                                        <div class="card card--back">
                                            <header class="card__header">
                                                <div class="card__header__text">
                                                    <p class="h3">Quote Details</p>
                                                </div>
                                                <div class="card__header__action">
                                                    <button class="card-close" @click="flipCard"><svg class="icon icon-Close"><use xlink:href="#icon-Close"></use></svg></button>
                                                </div>
                                            </header>

                                            <section class="card__body">
                                                <h3 class="text-meta-heading">Organization</h3>
                                                <p class="text-small-heading">{{post.organization}}</p>
                                                <h3 class="text-meta-heading">Date Captured</h3>
                                                <p class="text-small-heading">{{post.date_captured}}</p>
                                                <h3 class="text-meta-heading">Source</h3>
                                                <p class="text-small-heading">
                                                    {{post.source_name}}
                                                    <template v-if="post.source_certification">
                                                        , {{post.source_certification}}
                                                    </template>
                                                    <br>{{post.source_title}}
                                                </p>
                                                <h3 class="text-meta-heading">Value Driver</h3>
                                                <p class="text-small-heading">
                                                    <template v-for="(driver, driver_index) in post.value_driver">
                                                        {{driver.name}}<br>
                                                    </template>
                                                </p>
                                            </section>
                                        </div>
                                    </article>

                                    <article class="card card-grid-item" v-else-if="post.video_link" :data-video="getVideoId(post.video_link)">
                                        <header class="card__header">
                                            <div class="card__header__icon">
                                                <div v-for="(driver, driver_index) in post.value_driver" :key="driver.name+driver_index">
                                                    <svg v-if="driver_index == Object.keys(post.value_driver)[0]" class="icon" :class="['icon-'+driver.abbreviation+'-circle', driver.color]"><use v-bind="{'xlink:href':'#icon-'+driver.abbreviation+'-circle'}"></use></svg>
                                                </div>
                                            </div>
                                            <div class="card__header__text" v-if="post.value_driver[Object.keys(post.value_driver)[0]] && post.value_driver[Object.keys(post.value_driver)[1]]">
                                                <p class="text-regular">{{post.value_driver[Object.keys(post.value_driver)[0]].name}}</p>
                                                <p class="text-meta-heading">{{post.value_driver[Object.keys(post.value_driver)[1]].name}}</p>
                                            </div>
                                        </header>

                                        <div class="card__img img-fit has-video" @click="activateVideo(getVideoId(post.video_link),post.organization, post.headline )">
                                            <img :src="'https://img.youtube.com/vi/'+getVideoId(post.video_link)+'/hqdefault.jpg'">
                                            <svg class="icon icon-Play"><use xlink:href="#icon-Play"></use></svg>
                                        </div>

                                        <section class="card__body">
                                            <h3 class="text-meta-heading">{{post.organization}}</h3>
                                            <p class="text-intro-text">{{post.headline}}</p>
                                        </section>

                                        <div class="card__footer">
                                            <button class="button has-icon is-small text-white" v-if="post.value_driver[Object.keys(post.value_driver)[0]]" :class="post.value_driver[Object.keys(post.value_driver)[0]].color" @click="activateVideo(getVideoId(post.video_link),post.organization, post.headline )"><svg class="icon icon-Play"><use xlink:href="#icon-Play"></use></svg> Play Video</button>
                                        </div>

                                    </article>

                                    <article class="card-flip card-grid-item" v-else-if="post.disclosure">
                                        <div class="card card--front">
                                            <header class="card__header">
                                                <div class="card__header__icon">
                                                    <div v-for="(driver, driver_index) in post.value_driver" :key="driver.name+driver_index">
                                                        <svg v-if="driver_index == Object.keys(post.value_driver)[0]" class="icon" :class="['icon-'+driver.abbreviation+'-circle', driver.color]"><use v-bind="{'xlink:href':'#icon-'+driver.abbreviation+'-circle'}"></use></svg>
                                                    </div>
                                                </div>
                                                <div class="card__header__text" v-if="post.value_driver[Object.keys(post.value_driver)[0]] && post.value_driver[Object.keys(post.value_driver)[1]]">
                                                    <p class="text-regular">{{post.value_driver[Object.keys(post.value_driver)[0]].name}}</p>
                                                    <p class="text-meta-heading">{{post.value_driver[Object.keys(post.value_driver)[1]].name}}</p>
                                                </div>
                                            </header>

                                            <section class="card__body">
                                                <h3 class="text-meta-heading">{{post.organization}}</h3>
                                                <p class="text-intro-text">{{post.summary_content}}</p>
                                                <!-- <p class="text-meta-heading">{{post.disclosure}}</p> -->
                                            </section>

                                            <div class="card__footer">
                                                <button class="button has-icon is-small text-white" v-if="post.value_driver[Object.keys(post.value_driver)[0]]" :class="post.value_driver[Object.keys(post.value_driver)[0]].color" @click="flipCard"><svg class="icon icon-Info"><use xlink:href="#icon-Info"></use></svg> View Statistic Details</button>
                                            </div>

                                        </div>

                                        <div class="card card--back">
                                            <header class="card__header">
                                                <div class="card__header__text">
                                                    <p class="h3">Statistic Details</p>
                                                </div>
                                                <div class="card__header__action">
                                                    <button class="card-close" @click="flipCard"><svg class="icon icon-Close"><use xlink:href="#icon-Close"></use></svg></button>
                                                </div>
                                            </header>
                                            <section class="card__body">
                                                <h3 class="text-meta-heading">Organization</h3>
                                                <p class="text-small-heading">{{post.organization}}</p>
                                                <h3 class="text-meta-heading">Date Captured</h3>
                                                <p class="text-small-heading">{{post.date_captured}}</p>
                                                <h3 class="text-meta-heading">Disclosure</h3>
                                                <p class="text-small-heading">
                                                    {{post.disclosure}}
                                                </p>
                                                <h3 class="text-meta-heading">Value Driver</h3>
                                                <p class="text-small-heading">
                                                    <template v-for="(driver, driver_index) in post.value_driver">
                                                        {{driver.name}}<br>
                                                    </template>
                                                </p>
                                            </section>
                                        </div>
                                    </article>

                                    <article class="card card-grid-item" v-else>
                                        <header class="card__header">
                                            <div class="card__header__icon">
                                                <div v-for="(driver, driver_index) in post.value_driver" :key="driver.name+driver_index">
                                                    <svg v-if="driver_index == Object.keys(post.value_driver)[0]" class="icon" :class="['icon-'+driver.abbreviation+'-circle', driver.color]"><use v-bind="{'xlink:href':'#icon-'+driver.abbreviation+'-circle'}"></use></svg>
                                                </div>
                                            </div>
                                            <div class="card__header__text" v-if="post.value_driver[Object.keys(post.value_driver)[0]] && post.value_driver[Object.keys(post.value_driver)[1]]">
                                                <p class="text-regular">{{post.value_driver[Object.keys(post.value_driver)[0]].name}}</p>
                                                <p class="text-meta-heading">{{post.value_driver[Object.keys(post.value_driver)[1]].name}}</p>
                                            </div>
                                        </header>

                                        <div class="card__img img-fit" :class="post.value_driver[Object.keys(post.value_driver)[0]].color">
                                            <img :src="'/storage/'+ checkImageUrl(post.image) ">
                                        </div>

                                        <section class="card__body">
                                            <h3 class="text-meta-heading">{{post.organization}}</h3>
                                            <p class="text-intro-text">{{post.headline}}</p>
                                        </section>

                                        <div class="card__footer">
                                            <a href="#" @click.prevent="activateStory(post)" class="button has-icon is-small" v-if="post.value_driver[Object.keys(post.value_driver)[0]]" :class="post.value_driver[Object.keys(post.value_driver)[0]].color"><svg class="icon icon-Article"><use xlink:href="#icon-Article"></use></svg> Read Client Achievement Story</a>
                                        </div>

                                    </article>
                                </div>

                            </template>
                        </aside>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="component-fade" mode="out-in">
            <share-popup></share-popup>
        </transition>
    </section>
</template>

<script>
    import router from '../router.js';
    import EventBus from '../eventbus.js';
    import DriverCard from '../components/DriverCard';
    import SharePopup from '../components/SharePopup';
    import ResultsFilter from '../components/ResultsFilter';
    import MobileMenu from '../components/MobileMenu';

    export default {
        data : function() {
            return {
                posts: {},
                activeVideo: {
                    active: false,
                    id: '',
                    subHeading: '',
                    heading: '',
                    hideText: false
                },
                activeStory: {
                    active: false,
                    post: {}
                },
                relatedPosts: {},
                selectedDrivers: [],
                unselectedDrivers: [],
                page: 1,
                activeFilter: false,
                activeFilters: {},
                previousPostsCount: 0,
                noMorePosts: false,
                emptyResult: false,
                loadingResults: false,
                driversAccordionOpen: this.$store.getters.isMobile ? true : false,
                isMobileDashboardOpen: this.$store.getters.isMobileDashboardOpen,
                loadCustomDashboard: false,
                activeCustomDashboardKey: '',
                autoPlay: this.$store.getters.isMobile ? false : true
            }
        },
        created() {
            EventBus.$on( 'app.key.esc', (data) => {
                this.deactivateVideo();
                this.deactivateStory();
            });

            //when a driver is toggled,
            //update the vuex drivers to match
            EventBus.$on('portal.toggleDriver', (data) => {
                this.page = 1;
                this.$store.dispatch('updateDrivers', this.drivers);

                this.selectedDrivers = this.drivers.filter( function(driver) {
                    return driver.selected;
                });

                this.unselectedDrivers = this.drivers.filter( function(driver) {
                    return !driver.selected;
                });

                //lets go get the posts that match up to the new driver
                //selections
                this.getposts(this.page);
            });

            EventBus.$on('setActiveDashboardKey', (key) => {
                this.activeCustomDashboardKey = key;
                this.$store.commit('updateActiveDashboardKey', key);
            });

            EventBus.$on('dashboardToggle', () => {
                this.isMobileDashboardOpen = this.$store.getters.isMobileDashboardOpen;
            });

            EventBus.$on('updateCustomDashboard', (data) => {

                if ( !data[1] ) {
                    return; // don't save empty state
                }

                axios.post('/api/v1/update-dashboard', {
                    key: data[2],
                    drivers: data[1],
                    filters: data[0]
                })
                .then( ( response ) => {
                    // this assumes key exists in the first place
                    this.$nextTick(function () {
                    //   this.highlightSearchTerms();
                    })
                })
                .catch( function( error ) {
                    console.log( error );
                });
            });
        },
        computed: {
            drivers() {
                let drivers = this.$store.getters.drivers;
                return drivers.sort(compareValues('order'), 'asc');
            }
        },
        watch: {
            // original load more method, taken out due to double click that started happening
            // page(value) {
            //     console.log('click');
            //     if ( this.activeFilter ) {
            //         this.getFilteredPosts( this.activeFilters, this.activeFilter, true );
            //     } else {
            //         this.getposts(value);
            //     }
            // },
            activeStory(value) {

                if ( !value.active ) {
                    return {};
                }


                let _this = this;
                let category = this.activeStory.post.value_driver[Object.keys(this.activeStory.post.value_driver)[1]];

                let relatedPosts = this.posts.filter( function(post) {
                    if ( post.id === _this.activeStory.post.id ) {
                        return false;
                    } else {
                        for (var i = 0; i < post.value_driver.length; i++) {
                            if ( post.value_driver[i].id === category.id ) {
                                return true;
                            }
                        }
                        return false;
                    }
                });

                this.relatedPosts = _.sampleSize(relatedPosts, 3);
            },
            posts(value) {

                this.$nextTick(function () {
                    this.$store.dispatch('updatePosts', value);
                    this.resizeAllGridItems();
                    window.addEventListener("resize", this.resizeAllGridItems);

                    $('.js-init-video').magnificPopup({
                        type: 'iframe',
                        mainClass: 'mfp-fade',
                        removalDelay: 160,
                        preloader: false,
                        fixedContentPos: false,
                        callbacks: {
                          open: function() {
                            $('video').trigger('pause');
                          },
                          close: function() {
                            $('video').trigger('play');
                          }
                        }
                    });

                })
            },
            drivers() {
                this.selectedDrivers = this.drivers.filter( function(driver) {
                    return driver.selected;
                });

                this.unselectedDrivers = this.drivers.filter( function(driver) {
                    return !driver.selected;
                });
            },
        },
        updated: function () {
            this.$nextTick(function () {
                this.resizeAllGridItems();
                window.addEventListener("resize", this.resizeAllGridItems);
            });
        },
        destroyed() {
            this.$store.commit('updateMobileWidth', 768);
        },
        mounted() {
            this.$store.commit('updateIsPortal', true);
            this.$store.commit('updateIsMobile', window.innerWidth < 1200);
            EventBus.$emit('updateBottomNav');
            this.$store.commit('updateMobileWidth', 1200);

            $('body').css({
                backgroundImage: 'url("../Background_grey.jpg")'
            });

            $('body').removeClass('locked'); // due to story being closed by back button browser and body is locked
            EventBus.$emit('nav.updateAction', 'none');

            this.$nextTick(function () {
                this.resizeAllGridItems();
                window.addEventListener("resize", this.resizeAllGridItems);

                if ( $('.js-match-card-height').length > 0 ) {
                    $('.js-match-card-height .card').matchHeight();
                }
            })

            let curUrl = window.location.href;

            if ( curUrl.indexOf('?custom_dashboard=') !== -1 ) {
                this.loadCustomDashboard = true;
                let ajaxKey = curUrl.split('?custom_dashboard=')[1];
                axios.post('/api/v1/get-dashboard', {
                    key: ajaxKey
                })
                .then( ( response ) => {
                    sessionStorage.clear();

                    if ( response.data.status === 'ok' ) {
                        if ( response.data.state.length ) {
                            const customDashboard = JSON.parse(response.data.state[0].state_drivers_filters);

                            if ( customDashboard.drivers.length ) {
                                this.selectedDrivers = customDashboard.drivers.filter( function(driver) {
                                    return driver.selected;
                                });

                                this.unselectedDrivers = customDashboard.drivers.filter( function(driver) {
                                    return !driver.selected;
                                });

                                this.page = 1;
                                this.$store.dispatch('updateDrivers', customDashboard.drivers);
                                EventBus.$emit('checkFiltersCustomDashboard', customDashboard.filters);
                                EventBus.$emit('setActiveDashboardKey', ajaxKey);

                                // clear url
                                let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                                window.history.pushState({path:newurl},'',newurl);
                            } else {
                                alert('Custom dashboard not found');
                                window.location.href = '/portal';
                            }
                        } else {
                            alert('Custom dashboard not found');
                            window.location.href = '/portal';
                        }
                    } else {
                        alert('Custom dashboard not found');
                        window.location.href = '/portal';
                    }
                })
                .catch( function( error ) {
                    console.log( error );
                });
            } else {
                this.selectedDrivers = this.drivers.filter( function(driver) {
                    return driver.selected;
                });

                this.unselectedDrivers = this.drivers.filter( function(driver) {
                    return !driver.selected;
                });

                let posts = this.$store.getters.posts;
                this.activeFilters = this.$store.getters.activeFilters;

                if (
                    ( typeof this.activeFilters.asset_types !== 'undefined' && this.activeFilters.length ) ||
                    ( typeof this.activeFilters.region !== 'undefined' ) ) {
                    this.activeFilter = true;
                }

                if ( posts.length > 0 ) {
                    this.posts = posts.slice(0,28);
                    this.noMorePosts = false;
                } else {
                    if ( this.activeFilter ) {
                        this.getFilteredPosts(this.activeFilters, true, true);
                    } else {
                        this.getposts(this.page);
                    }
                }
            }

            // gtag events
            if ( !this.$store.getters.eventLoggedDrivers ) {
                if ( this.selectedDrivers.length ) {
                    this.selectedDrivers.map(function(driver) {
                        EventBus.$emit('gtag', {
                            action: 'select',
                            details: {
                                'event_category': 'Driver: ' + driver.name,
                                'event_label': 'Selected Driver',
                                'value': 1
                            },
                            name: 'parentDriver'
                        });

                        driver.children.map(function(child) {
                            if ( child.selected ) {
                                EventBus.$emit('gtag', {
                                    action: 'select',
                                    details: {
                                        'event_category': 'Sub driver: ' + child.name,
                                        'event_label': 'Selected Sub driver',
                                        'value': 1
                                    },
                                    name: 'childDriver'
                                });
                            }
                        })
                    })
                } else {
                    EventBus.$emit('gtag', {
                        action: 'view',
                        details: {
                            'event_category': 'Portal viewed no drivers',
                            'event_label': 'View Portal',
                            'value': 1
                        },
                        name: 'childDriver'
                    });
                }

                this.$store.commit('updateEventLogged', 'drivers');
            }

            window.addEventListener(
                'popstate', this.handleHistoryChange
            )
        },
        methods : {
            // testVideoImg( link ) {
            //     // could test if max is 404 and try hq but easier to just default to hq
            //     // available
            //     // default.jpg, hqdefault.jpg, mqdefault.jpg, sddefault.jpg, maxresdefault.jpg(not always available)
            //     console.log(link);
            //     return link.replace('maxresdefault.jpg', 'hqdefault.jpg');
            // },
            checkBackgroundPosition( background ) {
                return background ? background : 'center center';
            },
            handleHistoryChange() {
                // this handles state added by opened story/video which affects back button eg. you can get stuck not being able to go back
                // vs logic to add url parser/open videos/stories so they are real urls vs. fake ones
                if ( $('body').hasClass('locked') ) {
                    if ( $('.popup.content-popup').length ) {
                        this.deactivateStory();
                    } else {
                        this.deactivateVideo();
                    }
                    // history.pushState({}, null, '/portal');
                } else {
                    if ( window.location.href.indexOf('/portal') !== -1 && window.location.href.split('/portal')[1] === '' ) {
                        if ( $('section.dashboard').length ) {
                            // active drivers, go back to step 3
                            router.push('/custom-dashboard/3');
                        } else {
                            router.push('/');
                        }
                    }
                }
            },
            getPostLimit() {
                if ( this.$store.getters.isMobile ) {
                    return 10;
                }

                return 28;
            },
            toggleDriversAccordion() {
                if ( this.$store.getters.isMobile ) {
                    return true;
                }

                this.driversAccordionOpen = !this.driversAccordionOpen;
            },
            checkImageUrl( fileName ) {
                if ( !fileName ) {
                    return '';
                }

                if ( fileName.indexOf('.png') !== -1 || fileName.indexOf('.jpg') !== -1  || fileName.indexOf('.jpeg') !== -1 ) {
                    return fileName;
                } else {
                    return fileName + '.jpg';
                }
            },
            loadMore(page) {
                this.page += 1;

                if ( this.activeFilter ) {
                    this.getFilteredPosts( this.activeFilters, this.activeFilter, false );
                } else {
                    this.getposts(this.page);
                }
            },
            getposts(page) {
                if ( page === 1 ) {
                    this.posts = {};
                }

                this.noMorePosts = false;
                this.loadingResults = true;
                this.emptyResult = false;

                if ( this.activeCustomDashboardKey || this.$store.getters.activeDashboardKey ) {
                    let updateDashboardKey = this.activeCustomDashboardKey;

                    if ( !updateDashboardKey ) {
                        updateDashboardKey = this.$store.getters.activeDashboardKey;
                    }

                    EventBus.$emit('updateCustomDashboard', [this.activeFilters, this.drivers, updateDashboardKey]);
                }

                axios.post('/api/v1/posts', {
                    drivers: JSON.stringify( this.selectedDrivers ),
                    mobile: this.$store.getters.isMobile,
                    page: page
                })
                .then( ( response ) => {
                    $('.feed').css({
                        height: 'auto'
                    });

                    let queriedPosts = response.data;

                    if ( this.page === 1 ) {
                        this.posts = queriedPosts;

                        if ( queriedPosts.length < this.getPostLimit() ) {
                            this.noMorePosts = true;
                        }

                        if ( Array.isArray(queriedPosts) && !queriedPosts.length ) {
                            this.emptyResult = true;
                        }
                    } else {
                        this.posts = Object.assign({}, this.posts, queriedPosts);

                        if ( Object.keys(queriedPosts).length < this.getPostLimit() ) {
                            this.noMorePosts = true;
                        }

                        if ( Array.isArray(queriedPosts) && !Object.keys(queriedPosts).length ) {
                            this.emptyResult = true;
                        }
                    }

                    this.posts = Array.from(Object.keys(this.posts), k=>this.posts[k]);

                    // this.$nextTick(function () {
                    //     this.resizeAllGridItems();
                    //     window.addEventListener("resize", this.resizeAllGridItems);
                    // })

                    this.$nextTick(function () {
                    //   this.highlightSearchTerms();
                    })

                    this.loadingResults = false;
                })
                .catch( function( error ) {
                  console.log( error );
                });
            },
            getFilteredPosts(filters, filterActive, filteredSearch) {

                // update $store based on selected filters
                this.$store.commit('updateActiveFilters', filters);

                if ( filteredSearch ) {
                    this.page = 1;
                    this.posts = {};
                }

                this.activeFilter = filterActive;
                this.activeFilters = filters;

                this.noMorePosts = false;
                this.loadingResults = true;
                this.emptyResult = false;

                if ( this.activeCustomDashboardKey || this.$store.getters.activeDashboardKey ) {
                    let updateDashboardKey = this.activeCustomDashboardKey;

                    if ( !updateDashboardKey ) {
                        updateDashboardKey = this.$store.getters.activeDashboardKey;
                    }

                    EventBus.$emit('updateCustomDashboard', [this.activeFilters, this.drivers, updateDashboardKey]);
                }

                axios.post('/api/v1/get-filtered-posts', {
                    asset_types: filters.asset_types,
                    region: filters.region,
                    organization: filters.organization,
                    text_search: filters.textSearch,
                    drivers: JSON.stringify( this.selectedDrivers ),
                    page: this.page,
                    mobile: this.$store.getters.isMobile,
                })
                .then( (response) => {
                    let queriedPosts = response.data;

                    if ( this.page === 1 ) {
                        this.posts = queriedPosts;

                        if ( queriedPosts.length < this.getPostLimit() ) {
                            this.noMorePosts = true;
                        }

                        if ( Array.isArray(queriedPosts) &&  !queriedPosts.length ) {
                            this.emptyResult = true;
                        }
                    } else {
                        this.posts = Object.assign({}, this.posts, queriedPosts);

                        if ( Object.keys(queriedPosts).length < this.getPostLimit() ) {
                            this.noMorePosts = true;
                        }

                        if ( Array.isArray(queriedPosts) &&  !Object.keys(queriedPosts).length ) {
                            this.emptyResult = true;
                        }
                    }

                    // Hide more posts button if searching with string
                    if ( filters.textSearch !== '' ) {
                      this.noMorePosts = true;
                    }

                    this.posts = Array.from(Object.keys(this.posts), k=>this.posts[k]);

                    // this.$nextTick(function () {
                    //     this.resizeAllGridItems();
                    //     window.addEventListener("resize", this.resizeAllGridItems);
                    // })

                    this.$nextTick(function () {
                    //   this.highlightSearchTerms();
                    })

                    this.loadingResults = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            updateFiltersFromStore() {

            },
            highlightSearchTerms() {
              const filters = this.activeFilters;
              if ( filters.textSearch !== '' ) {
                const searchTerms = filters.textSearch.split( ' ' );
                $.each( searchTerms, function( index, term ) {
                  $( '.card-grid .card:contains("' + term + '")' ).html( function( _, html ) {
                    return html.replace( term, '<span class="card__search__highlight">' + term + '</span>' );
                  } );
                });
              }
            },
            resizeAllGridItems() {
                let allItems = document.getElementsByClassName("card-grid-col");
                for(let x=0;x<allItems.length;x++){
                  this.resizeGridItem(allItems[x]);
                }
            },
            getVideoId(url) {
                  let ID = '';
                  url = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
                  if(url[2] !== undefined) {
                    ID = url[2].split(/[^0-9a-z_\-]/i);
                    ID = ID[0];
                }
                else {
                    ID = url;
                }

                return ID;
            },
            activateStory(post) {
                $('body').addClass('locked');
                history.pushState({}, null, '/portal/reading-story');
                this.activeStory = {
                    active: true,
                    post: post
                };
            },
            deactivateStory() {
                $('body').removeClass('locked');
                this.activeStory = {
                    active: false,
                    post: {}
                }
                history.pushState({}, null, '/portal');
            },
            activateVideo(id, subHeading, heading) {
                $('body').addClass('locked');
                history.pushState({}, null, '/portal/watching-video');
                this.activeVideo = {
                    id: id,
                    subHeading: subHeading,
                    heading: heading,
                    active: true,
                    hideText: false
                };
                EventBus.$emit('gtag', {
                    action: 'watch',
                    details: {
                        'event_category': 'Played video: ' + heading,
                        'event_label': 'Video Played',
                        'value': 1
                    }
                });
            },
            deactivateVideo() {
                $('body').removeClass('locked');
                this.activeVideo = {
                    active: false,
                    id: '',
                    subHeading: '',
                    heading: '',
                    hideText: false
                };
                history.pushState({}, null, '/portal');
            },
            playVideo(event) {
                if ( !this.$store.getters.isMobile ) {
                    event.detail.plyr.play();
                }
            },
            videoplaying(event) {
                if ( event.detail.plyr.media.currentTime >= 5 ) {
                    this.activeVideo.hideText = true;
                }
            },
            closePopup() {
                this.deactivateVideo();
            },
            flipCard(event) {
                $(event.target).closest('.card-flip').toggleClass('active');
                EventBus.$emit('gtag', {
                    action: 'read',
                    details: {
                        'event_category': 'Opened card: ' + event.target.textContent,
                        'event_label': 'Read card',
                        'value': 1
                    }
                });
            },
            resizeGridItem(item) {
                // let grid = document.getElementsByClassName("card-grid")[0];
                // let rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
                // let rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));

                // grid.style.gridAutoRows = "auto";
                // grid.style.alignItems = "self-start";
                // grid.querySelectorAll(".card-grid-col").forEach(item => {
                //     item.style.gridRowEnd = `span ${Math.ceil(
                //         (item.clientHeight + rowGap) / (rowHeight + rowGap)
                //     )}`;
                // });
                // grid.removeAttribute("style");
            },
            onChangeEventHandler() {
            },
            expandCards() {
                if ( this.$store.getters.isMobile ) {
                    return true;
                }

                this.driversAccordionOpen = !this.driversAccordionOpen;
            }
        },
        components: {
            DriverCard,
            SharePopup,
            ResultsFilter,
            MobileMenu
        },
    }
</script>

<style lang="css" scoped>
    .portal.mobile {
        padding-top: 2em;
    }

    .portal.mobile .container.first {
        padding-left: 16px;
        padding-right: 16px;
    }

    .portal.mobile .mobile-menu {
        margin-bottom: 1em;
    }

    .col-2 {
        /*width: 20%;*/
    }

    .card-grid .first-child {
        min-width: 100% !important; /* mainly for edge case where less than 4 cards */
    }

    .card {
        height: 100% !important;
        cursor: pointer;
    }

    .card.collapsed {
        display: flex;
        align-items: center;
    }

    .card.collapsed .card__body *:not(h3) {
        display: none;
    }

    .card.collapsed .card__header {
        height: 100%;
    }

    .card.collapsed .card__body h3 {
        margin-bottom: 0;
    }

    .accordion-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        padding-top: 0.5em;
    }

    .accordion-container img.up {
        transform: rotate(180deg);
    }

    .accordion-container button {
        padding: 0.5em;
    }

    .accordion-container h4 {
        width: auto;
        word-spacing: initial;
        letter-spacing: initial;
        margin: 0;
    }

    .load-more {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 10em;
    }

    .load-more button {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .load-more button img {
        margin-left: 1em;
    }

    .load-more__no-results {
        font-size: 1.25em;
    }

    /* mobile styling */
    .portal.mobile .dashboard {
        position: fixed;
        top: 100vh;
        left: 0;
        width: 100%;
        height: 100vh;
        display: block;
        overflow-y: auto;
        background-color: #FEFEFE;
        z-index: 3;
        transition: all 0.3s ease-in-out;
        overflow-x: hidden;
    }

    .portal.mobile .dashboard.show {
        top: 0;
    }

    .portal.mobile .bottom-nav {
        display: none;
    }

    .portal.mobile .text-large-heading {
        position: relative;
        text-align: center;
        margin-top: 1em;
        padding-top: 1em;
    }

    .portal.mobile .dashboard .text-large-heading::before {
        position: absolute;
        top: 0;
        left: calc((100% - 60px) / 2);
        content: '';
        width: 60px;
        height: 1px;
        background-color: #979797;
        display: block;
    }

    .portal.mobile .text-sub-heading {
        text-align: center;
    }

    .portal.mobile .dashboard .grid {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-bottom: 8em;
    }

    .portal.mobile .grid .col-2:first-of-type::after {
        content: 'Applied Drivers';
        display: block;
        font-size: 1.75em;
        font-weight: 400;
        width: 100%;
        text-align: center;
        padding-bottom: 1em;
    }

    .portal.mobile .dashboard .grid .col-2 {
        width: 90%;
        max-width: 500px;
    }

    .portal.mobile .dashboard .grid .col-2 {
        padding-bottom: 0;
    }

    .portal.mobile .dashboard .grid .col-2:nth-of-type(2) {
        padding-top: 0;
    }

    .portal.mobile .card {
        box-shadow: none;
        height: auto !important;
    }

    .portal.mobile .card__body {
        padding-left: 0;
        padding-right: 0;
    }

    @media screen and (max-width: 1700px) {
        .popup.video-popup .close-button {
            top: 1em !important;
            right: 1em !important;
        }
    }

    @media screen and (max-width:1200px) {
        .feed.has-dashboard {
            margin-top: 0;
        }

        .popup.content-popup {
            height: 100vh;
            overflow-x: hidden;
        }


        .popup.video-popup {
            height: 100vh;
            overflow-x: hidden;
        }
    }

    @media screen and (max-width: 880px) {
        .col-auto {
            min-width: 275px;
        }

        .text-meta-heading {
            padding-left: 2em;
        }
    }

    @media screen and (max-width: 790px) {
        .col-auto {
            min-width: 250px;
        }

        .popup.content-popup .text-large-heading {
            text-align: left;
        }

        .content-popup__banner {
            padding: 1em 0 5em 0;
        }
    }

    @media screen and (max-width: 768px) {
        .popup.content-popup .col-7,  .popup.content-popup .col-3 {
            width: 100%;
        }

        .popup.content-popup .col-auto:last-of-type {
            margin-bottom: 10em;
        }
    }

    @media screen and (max-width: 480px) {
        .portal {
            padding-bottom: 3.5em;
        }

        .load-more {
            padding-top: 2em;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/Portal.vue